<div class="hero">
  <div class="hero-overlay">
  </div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          Our Year In Review
        </h1>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <div class="top-first-section">
    <div>
      <h1>
        <span class="top-first-section-top-text fw-bold">In total over</span>
      </h1>
    </div>
    <div>
      <img src="/assets/images/identibase-review/pets-registered.png" class="top-first-section-image" alt="pets-registered"/>
    </div>
    <div class="top-first-section-bottom-text">
      <h1 class="fw-bold">
        pets are registered!
      </h1>
    </div>
  </div>
  <div class="top-second-section">
    <div class="top-second-section-text">
      <h1 class="fw-bold">That's more pets than seats in every football stadium in the UK combined.</h1>
    </div>
    <div class="top-second-section-image-container">
      <img src="/assets/images/identibase-review/football-stadium.png" class="top-second-section-image-container-content" alt="football-stadium"/>
    </div>
  </div>
  <div class="top-third-section">
    <div class="top-third-section-title">
      <h1 class="fw-bold">And we couldn't have done it without you</h1>
    </div>
    <div class="top-third-section-content">
      <div class="top-third-section-content-right">
        <img src="/assets/images/identibase-review/review-one.png" class="top-third-section-content-right-image" alt="review-one"/>
      </div>
      <div class="top-third-section-content-left">
        <img src="/assets/images/identibase-review/review-two.png" class="top-third-section-content-left-image" alt="review-two"/>
      </div>
    </div>
  </div>
  <div class="top-bottom-section">
    <div class="top-bottom-section-left">
      <div class="top-bottom-section-left-image">
        <img src="/assets/images/identibase-review/20000-with-text.png" class="top-bottom-section-left-image-content" alt="20000-with-text"/>
      </div>
    </div>
    <div class="top-bottom-section-right">
      <div class="top-bottom-section-right-title">
        <h3 class="fw-bold">And more than 70% of missing pets with identialert made it home safely</h3>
      </div>
      <div class="top-bottom-section-right-button">
        <button
        class="btn btn-lg w-50 btn-brand-orange"
        routerLink="/identialert"
        type="button">
        Find Out More
      </button>
      </div>
    </div>
  </div>
  <div class="center-top-section">
    <div class="center-top-section-left">
      <div class="center-top-section-left-text">
        <h2 class="fw-bold">With pets reunited over 300 miles from home...</h2>
      </div>
      <div class="text-center">
        <img src="/assets/images/identibase-review/pets-missing-trail.png" class="center-top-section-left-image" alt="pets-missing-trail"/>
      </div>
    </div>
    <div class="center-top-section-right">
      <img src="/assets/images/identibase-review/pet-protection-experts.png" class="center-top-section-right-image" alt="pet-protection-experts"/>
      <div class="center-top-section-right-text">
        <h2 class="fw-bold">...our Pet Protection Experts were on hand 24/7 solving your queries</h2>
      </div>
    </div>
  </div>
  <div class="center-mid-section">
    <div class="center-mid-section-left">
      <div class="center-mid-section-left-title">
        <h1 class="fw-bold">You registered pets all over the UK, most popular being:</h1>
      </div>
      <div class="center-mid-section-left-list">
        <ol>
          <h2 class="fw-bold"><li>London</li></h2>
          <h2 class="fw-bold"><li>Manchester</li></h2>
          <h2 class="fw-bold"><li>Birmingham</li></h2>
          <h2 class="fw-bold"><li>Nottingham</li></h2>
          <h2 class="fw-bold"><li>Glasgow</li></h2>
        </ol>
      </div>
    </div>
    <div class="center-mid-section-right">
      <div class="center-mid-section-right-image">
        <img src="/assets/images/identibase-review/england-registration-map.png" class="center-mid-section-right-image-content" alt="england-registration-map"/>
      </div>
    </div>
  </div>
  <div class="center-bottom-section">
    <div class="center-bottom-section-title">
      <h1 class="fw-bold">Most Popular Pet Names:</h1>
    </div>
    <div class="center-bottom-section-content">
      <div class="center-bottom-section-content-image">
        <img src="/assets/images/identibase-review/most-popular-pet-names.png" class="center-bottom-section-content-image-content" alt="most-popular-pet-names"/>
      </div>
      <div class="center-bottom-section-content-list">
        <ol>
          <h2 class="fw-bold"><li>Luna</li></h2>
          <h2 class="fw-bold"><li>Milo</li></h2>
          <h2 class="fw-bold"><li>Bella</li></h2>
          <h2 class="fw-bold"><li>Coco</li></h2>
          <h2 class="fw-bold"><li>Willow</li></h2>
        </ol>
      </div>
    </div>
  </div>
  <div class="bottom-top-section">
    <div class="bottom-top-section-title">
      <h1 class="fw-bold">Top-registered dog breeds:</h1>
    </div>
    <div class="bottom-top-section-container">
      <div class="bottom-top-section-container-card">
        <div class="bottom-top-section-container-card-number">#1</div>
        <div class="bottom-top-section-container-card-type">Labrador</div>
        <div class="bottom-top-section-container-card-image">
          <img src="/assets/images/identibase-review/labrador-dog-breed.png" class="bottom-top-section-container-card-image-content" alt="football-stadium"/>
        </div>
      </div>
      <div class="bottom-top-section-container-card">
        <div class="bottom-top-section-container-card-number">#2</div>
        <div class="bottom-top-section-container-card-type">Crossbreed</div>
        <div class="bottom-top-section-container-card-image">
          <img src="/assets/images/identibase-review/cross-breed-dog.png" class="bottom-top-section-container-card-image-content" alt="football-stadium"/>
        </div>
      </div>
      <div class="bottom-top-section-container-card">
        <div class="bottom-top-section-container-card-number">#3</div>
        <div class="bottom-top-section-container-card-type">Cocker Spaniel</div>
        <div class="bottom-top-section-container-card-image">
          <img src="/assets/images/identibase-review/cocker-dog-breed.png" class="bottom-top-section-container-card-image-content" alt="football-stadium"/>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-mid-section">
    <div class="bottom-mid-section-title">
      <h1 class="fw-bold">Longest Pet Name:</h1>
    </div>
    <div class="bottom-mid-section-content">
      <div class="bottom-mid-section-content-text">
        <h1 class="fw-bold">Countess Audrey Heidi Ferrarina Leslie of Arduthie</h1>
      </div>
      <div class="bottom-mid-section-content-image">
        <img src="/assets/images/identibase-review/longest-pet-name.png" class="bottom-mid-section-content-image-content" alt="football-stadium"/>
      </div>
    </div>
  </div>
  <div class="bottom-bottom-section">
    <div class="bottom-bottom-section-left">
      <div class="bottom-bottom-section-left-title">
        <h2 class="fw-bold">Most common pet star sign:</h2>
      </div>
      <div class="bottom-bottom-section-left-image">
        <img src="/assets/images/identibase-review/pet-star-sign.png" class="bottom-bottom-section-left-image-content" alt="pet-star-sign"/>
      </div>
    </div>
    <div class="bottom-bottom-section-right">
      <div class="bottom-bottom-section-right-title">
        <h2>Top Pet Species</h2>
      </div>
      <div class="bottom-bottom-section-right-list_container">
        <ol>
          <h2 class="fw-bold"><li>Cat</li></h2>
          <h2 class="fw-bold"><li>Dog</li></h2>
          <h2 class="fw-bold"><li>Horse</li></h2>
          <h2 class="fw-bold"><li>Rabbit</li></h2>
          <h2 class="fw-bold"><li>Ferret</li></h2>
        </ol>
      </div>
    </div>
  </div>
</div>
